import FieldUsers from "../../../generic/users/users"
import FieldConfig from "../../../proto/field-config"
import FieldTaskReportedByUsers_TableCell from "../../task/reported-by-users/render/table/table-cell"
import {AggregateFunctionType} from "../../../../data-structures/aggregators/types"

export default class FieldGroupReportedByUsers extends FieldUsers {

    constructor(config: FieldConfig) {
        super(config)

        this.icon       = 'i5-users'
        this.label      = 'Reported by'

        this.hasCalculatedValues                    = true
        this.renderComponents.tableCell             = FieldTaskReportedByUsers_TableCell
        this.renderComponents.tableCellCalculated   = FieldTaskReportedByUsers_TableCell
    }

    canEdit(model: any): boolean {
        return false
    }

    getDefaultAggregateFunction(): AggregateFunctionType {
        return AggregateFunctionType.USERS_UNION
    }
}
